import React from "react";
import { useSearchParams } from "react-router-dom";
import FinancePageHead, { FinanceTabs } from "../../components/FinancePageHead";
import BillToPartiesTab from "../BillToPartiesTab";
import FinanceAccounts from "../FinanceAccounts";
import AccountsReceivable from "../AccountsReceivable";
import { FINANCE_SECTIONS, SETTINGS_TABS } from "../../utils/financeTerms";
import "../../assets/css/DigixLeads.css";
import "../../assets/css/FinanceManagement.css";

const TABS = [
  {
    key: SETTINGS_TABS.billTo,
    label: "Bill To",
    hint: "Companies or people an invoice is billed to, printed in its \"Bill To\" block.",
  },
  {
    key: SETTINGS_TABS.clientAccounts,
    label: "Client Bank Accounts",
    hint: "Your clients' bank details, used when you note who a payment came from.",
  },
  {
    key: SETTINGS_TABS.ourAccounts,
    label: "Our Bank Accounts",
    hint: "Where clients send money. Printed on invoices and used when you record or make a payment.",
  },
];

/** Finance > Finance Settings: Bill To companies and bank accounts. */
function FinanceSettingsPage() {
  const [params, setParams] = useSearchParams();
  const active = TABS.some((t) => t.key === params.get("tab")) ? params.get("tab") : TABS[0].key;
  const tab = TABS.find((t) => t.key === active);

  return (
    <div className="digixleads-container finance-management-page">
      <FinancePageHead section={FINANCE_SECTIONS.settings} />
      <div className="main-card">
        <FinanceTabs
          tabs={TABS}
          active={active}
          onChange={(key) => setParams({ tab: key }, { replace: true })}
          ariaLabel="Finance settings section"
        />
        <div className="finance-management-tab-body">
          <p className="finance-aging-hint">{tab.hint}</p>
          {active === SETTINGS_TABS.billTo && <BillToPartiesTab />}
          {active === SETTINGS_TABS.ourAccounts && <FinanceAccounts />}
          {active === SETTINGS_TABS.clientAccounts && <AccountsReceivable />}
        </div>
      </div>
    </div>
  );
}

export default FinanceSettingsPage;
